export default __webpack_public_path__ + "static/media/logo-intro.69c704d5.png";